<template>
  <q-layout view="hHh lpR fFf">

    <q-header class="bg-white text-black">
      <q-toolbar style="padding:2px">
        <q-toolbar-title >
            <div class="row" style="">
                <q-btn class="col-*" size="md" color="primary" flat dense icon="menu" @click="showSummary = true" style="width:30px; margin:0; padding: 0;"/>
                <q-input class="col" autofocus clearable type="text" tag="barcodeInput" dense outlined debounce="100" :value="barcode" @input="v => scanItem(v)">
                    <template v-slot:append>
                    <q-icon name="document_scanner" />
                    </template>            
                </q-input>
            </div>
        </q-toolbar-title>
      </q-toolbar>
    </q-header>
    <q-page-container>
    <div class="col">
        <div class="text-center" style="font-size:18px; font-weight:bold">{{order.orderNumber}}</div>
        <div class="text-center">{{order.name}}</div>
    </div>
        <div v-if="!item && firstLoad == false && !loading">
            <div style="width: 180px; margin:0 auto;">
                <img width="180" src="../assets/warning.jpg" />
            </div>  
            <p class="text-center" style="font-weight:bold; font-size: 35px;">BARCODE NOT FOUND</p>
        </div>
        <q-inner-loading :showing="loading">
            <q-spinner-gears size="100px" color="primary" />
        </q-inner-loading>
        <div style="padding: 0; margin: 0 5px;">
            <q-table     
                :hide-pagination="true"
                :rows-per-page-options="[0]"                
                :data="order.items" 
                row-key="skuId"
                :columns="columns"
                hide-header 
            >
                <template v-slot:body="props">
                    <q-tr :props="props" class="row" style="height:40px" @click="showAssignItemDialog(props)">    
                        <q-td class="col-*" style="height:40px;padding: 0; margin: 0; width: 30px;" @click.stop="markAsCompletedToogle(props)">
                            <div style="border: solid 1px silver; width: 20px; height: 20px;margin:10px 5px" >
                                <q-icon name="check" size="sm" style="color: green; margin-top:-4px; margin-left:-3px" v-if="props.row.completed"/>
                            </div>                            
                        </q-td>
                        <q-td class="col scroll_content" style="height:40px;overflow:auto; width:0px;padding: 0; margin: 0" key="col1" >
                                <div class="row" style="font-size:18px; line-height: 24px;">{{props.row.sku.product.name}}</div>
                                <div class="row" style="font-size:12px; line-height: 12px;">{{getSecondLine(props.row.sku.product.attributes)}}</div>                                
                        </q-td>
                        <q-td class="col-*" key="col2" style="display: block; height:40px; width:40px; padding: 0; margin: 0 auto;" >
                            <div class="row" style="margin: 4px auto 0 auto; display: block; height:15px; width: 15px; border:1px solid silver; border-radius: 5px;" :style="`background-color:${props.row.sku.options.colour.hex}`"></div>
                            <p class="text-center text-bold" style="font-family:monospace">{{props.row.qty}}</p>
                        </q-td>
                    </q-tr>
                    <q-tr :props="props">
                        <q-td auto-width >
                            <q-table           
                            dense
                            :hide-pagination="true"
                            :rows-per-page-options="[0]"                        
                            :columns="[
                                {
                                    label: 'Barcode ID',
                                    field: 'barcode',
                                    name: 'barcode',
                                    required: false,
                                    align: 'center',
                                    sortable: true
                                },
                                {
                                    label: 'Status',
                                    field: 'status',
                                    name: 'status',
                                    required: false,
                                    align: 'center',
                                    sortable: true
                                },
                                {
                                    field: 'type',
                                    name: 'type',
                                    required: false,
                                    align: 'center',
                                    sortable: false
                                }                                          
                            ]" 
                            :data="props.row.itus" 
                            row-key="id" >



                                <template v-slot:header="props">
                                    <q-tr :props="props" class="row" style="margin:0; padding:0">
                                        <q-th class="col-*" style="width: 80px; padding: 5px 0; margin: 0;" key="barcode" :props="props">Barcode</q-th>
                                        <q-th class="col" style="margin:0;padding: 5px 0;" key="status" :props="props">Status</q-th>
                                        <q-th class="col-*" key="type" style="width: 30px; margin:0;padding:0" :props="props"></q-th>                                              
                                    </q-tr>
                                </template>                            
                                <template v-slot:body="props">
                                    <q-tr @click="showSwapItemDialog(props)"  :props="props" class="row" style="overflow: hidden; margin:0; padding:0" :style="`${(props.row.check)?'background-color:greenyellow':''}`">
                                        <q-td dense class="col-*" style="font-family: monospace;width: 80px; padding: 4px 0; display: block;" key="barcode" :props="props">{{props.row.barcode}}</q-td>
                                        <q-td class="col scroll_content" key="status" :props="props" style="overflow: auto; width: 0px ; padding: 4px 0; margin:0;">{{props.row.status}}</q-td>
                                        <q-td class="col-*" style="width: 30px; margin:0;padding:0" key="type" :props="props">
                                            <q-btn size="sm" flat color="primary" icon="clear" @click="removeScannedItemFromOrder(props.row)" style="width:30px;margin:0;padding:0"/>
                                        </q-td>
                                    </q-tr>                            
                                </template>                        
                            </q-table>
                        </q-td>                    
                        
                    <!-- </q-td> -->
                    </q-tr>                    
                </template>
            </q-table>
        </div>

    <!-- Summary popup -->
    <q-dialog v-model="showSummary" full-width full-height>
        <q-card>
        <q-layout view="hHh lpR fff" container style="height: 100%" class="bg-white text-black">
            <q-header class="bg-white text-black">
            <q-toolbar>
                <q-toolbar-title>
                                <q-tabs
            v-model="tab"
            dense
            class="text-grey"
            active-color="primary"
            indicator-color="primary"
            align="justify"
            >
            <q-tab name="menu" label="Menu" />
            </q-tabs>
                </q-toolbar-title>
            </q-toolbar>
            </q-header>

            <q-page-container>
                <q-tab-panels v-model="tab" animated >
                    <q-tab-panel name="menu">
                        <q-card class="my-card">
                            <q-card-section>
                                <div class="text-bold" style="margin:0 0 10px 0">Complete Order Packing</div>
                                <div>Completed the packing process and set "Packed" date on the order. </div>
                                <div>You need to complete the order to be able to print the packing list.</div>
                            </q-card-section>
                            <q-card-actions align="center" style="margin:-12px 0 0 0;padding:">
                                <q-btn color="primary" dense label="Complete Order Packing" @click="completeOrderPacking()" :disable="order.packed != null"/>
                            </q-card-actions>                            
                        </q-card>
                        <br>                      
                        <q-card class="my-card">
                            <q-card-section>
                                <div class="text-bold" style="margin:0 0 10px 0">Print Packing List</div>
                                <div>Print the autogenerated packing list for this order.</div>
                            </q-card-section>
                            <q-card-actions align="center" style="margin:-12px 0 0 0;padding:">
                                <q-btn color="primary" dense flat size="lg" icon="print" @click="printPackingList()" />
                            </q-card-actions>                            
                        </q-card>                       
                    </q-tab-panel>
                </q-tab-panels>
            </q-page-container>

        </q-layout>

        </q-card>    

    </q-dialog>

    <!-- Confirmation Dialog Mark as Completed -->
    <q-dialog v-model="showMarkAsCompleted" persistent v-if="propData">
      <q-card>
        <q-card-section class="row items-center">
          <span class="q-ml-sm" v-if="!propData.row.completed">Set this item as "checked"?</span>
          <span class="q-ml-sm" v-if="propData.row.completed">Set this item as "unchecked"?</span>
        </q-card-section>

        <q-card-actions align="right">
          <q-btn flat label="Cancel" color="primary" v-close-popup @click="propData=''"/>
          <q-btn flat label="Mark as checked" color="primary" v-close-popup @click="toogleCompleted()" v-if="!propData.row.completed"/>
          <q-btn flat label="Uncheck item" color="primary" v-close-popup @click="toogleCompleted()" v-if="propData.row.completed"/>
        </q-card-actions>
      </q-card>
    </q-dialog>    
    
    <!-- Dialog Assign item to listed product -->
    <q-dialog v-model="assignItemDialog" persistent v-if="selectedProduct && (selectedProduct.row.itus.length < selectedProduct.row.qty)">
      <q-card>
        <q-card-section>
            <div class="row">Assign an item to:</div>
            <div class="row text-bold">{{selectedProduct.row.sku.product.attributes.brand}} - {{selectedProduct.row.sku.product.name}} - {{selectedProduct.row.sku.options.colour.group}} ({{selectedProduct.row.sku.options.colour.name}})</div>
            <div>Items assigned: {{selectedProduct.row.itus.length}} of {{selectedProduct.row.qty}}</div>
                <q-input class="col" autofocus clearable type="text" dense outlined debounce="600" :value="barcodeToAssign" @input="v => scanBarcodeToAssign(v)">
                    <template v-slot:append>
                    <q-icon name="document_scanner" />
                    </template>            
                </q-input>
            <div v-if="itemToAssign && itemToAssign.product.id == selectedProduct.row.sku.product.id" style="padding: 5px;margin: 5px 0; border: solid 1px black; border-radius:5px;">
                <!-- <img :src="itemToAssign.product.images[0].url" alt=""> -->
                <div>Barcode: {{itemToAssign.barcode}}</div>
                <div>Status: {{itemToAssign.status}}</div>
                <div class="row">Colour: {{itemToAssign.sku.options.colour.group}} ({{itemToAssign.sku.options.colour.name}})<div style="border-radius:50px;width:18px; height:18px;border:solid 1px silver; margin:0 5px;" :style="`background-color:${itemToAssign.sku.options.colour.hex}`"></div></div>
                <div style="margin:10px 0;">
                    <div v-if="itemToAssign.status != 'available'">
                        <q-icon name="warning" color="red" />This item is not available.
                    </div>                
                    <div v-if="selectedProduct.row.sku.options.colour.group != itemToAssign.sku.options.colour.group || selectedProduct.row.sku.options.colour.name != itemToAssign.sku.options.colour.name">
                        <q-icon name="warning" color="orange" />This item has a different colour.
                    </div>
                </div>                
            </div>
            <div v-if="itemToAssign && itemToAssign.product.id != selectedProduct.row.sku.product.id" style="padding: 5px;margin: 5px 0; border: solid 2px red; border-radius:5px;">
            This item can't be assigned to the order because it is a different product.
            </div>
                 
        </q-card-section>

        <q-card-actions align="right">
          <q-btn flat label="Cancel" color="primary" v-close-popup/>
          <q-btn label="Assign" @click="assignItemtoOrder(selectedProduct,itemToAssign)" :disable="disableAssignBtn(selectedProduct,itemToAssign)" color="primary" v-close-popup/>          
        </q-card-actions>
      </q-card>
    </q-dialog>

    <!-- Dialog Swap Preassigned item -->
    <q-dialog v-model="swapItemDialog" persistent v-if="selectedItemToSwap">
      <q-card>
        <q-card-section>
            <div class="row">Swap:</div>
            <div style="border: 1px solid black; border-radius:5px; margin: 5px 0; padding: 5px">
                <div class="row text-bold">Name: {{selectedItemToSwap.row.sku.product.name}}</div>
                <div class="row text-bold">Brand: {{selectedItemToSwap.row.sku.product.attributes.brand}}</div>                
                <div class="row text-bold">Barcode: {{selectedItemToSwap.row.barcode}}</div>
                <div class="row text-bold">Status: {{selectedItemToSwap.row.status}}</div>
                <div class="row text-bold">Colour: {{selectedItemToSwap.row.sku.options.colour.group}} ({{selectedItemToSwap.row.sku.options.colour.name}})<div style="border-radius:50px;width:18px; height:18px;border:solid 1px silver; margin:0 5px;" :style="`background-color:${selectedItemToSwap.row.sku.options.colour.hex}`"></div></div>
            </div>
            <div>With:</div>
            <div v-if="itemToSwap && (selectedItemToSwap.row.sku.product.id == itemToSwap.product.id)" style="padding: 5px;margin: 5px 0; border: solid 1px black; border-radius:5px;">
                    
                <div>Name: {{itemToSwap.product.name}}</div>
                <div>Brand: {{itemToSwap.product.attributes.brand}}</div>                
                <div>Barcode: {{itemToSwap.barcode}}</div>
                <div>Status: {{itemToSwap.status}}</div>
                <div class="row">Colour: {{itemToSwap.sku.options.colour.group}} ({{itemToSwap.sku.options.colour.name}})<div style="border-radius:50px;width:18px; height:18px;border:solid 1px silver; margin:0 5px;" :style="`background-color:${itemToSwap.sku.options.colour.hex}`"></div></div>                
                <div style="margin:10px 0;">
                    <div v-if="itemToSwap.status != 'available'">
                        <q-icon name="warning" color="red" />This item is not available.
                    </div>
                    <div v-if="selectedItemToSwap.row.sku.options.colour.group != itemToSwap.sku.options.colour.group || selectedItemToSwap.row.sku.options.colour.name != itemToSwap.sku.options.colour.name">
                        <q-icon name="warning" color="orange" />This item has a different colour.
                    </div>                                   
                </div>              
            </div>
                <q-input class="col" autofocus clearable type="text" dense outlined debounce="600" :value="barcodeToSwap" @input="v => scanBarcodeToSwap(v)">
                    <template v-slot:append>
                    <q-icon name="document_scanner" />
                    </template>            
                </q-input>            
        </q-card-section>

        <q-card-actions align="right">
          <q-btn flat label="Cancel" color="primary" v-close-popup/>
          <q-btn label="Assign" :disable="disableSwapBtn(selectedItemToSwap,itemToSwap)" color="primary" v-close-popup @click="swapItem(selectedItemToSwap,itemToSwap)" />          
        </q-card-actions>
      </q-card>
    </q-dialog>               

    </q-page-container>

    <q-footer class="bg-white">
      <q-toolbar style="min-height:0">
        <q-toolbar-title  >
            <div style="padding: 0; margin: 0; font-size: 8px; border:1px dotted black; color:black">This is a status bar, to let people know what is going on</div>
        </q-toolbar-title>
      </q-toolbar>
    </q-footer>

  </q-layout>
</template>

<script>
import gql from 'graphql-tag';
import { jsPDF } from "jspdf";
import _ from "lodash";

export default {
  name: 'scan_stocktake',
  data(){
    return {
      selectedProduct:"",
      enableAssignBtn:true,  
      barcodeToAssign:'',
      barcodeToSwap:'',
      itemToAssign:'',  
      assignItemDialog: false,
      swapItemDialog: false,
      selectedItemToSwap: "",
      itemToSwap:'',
      propData:"",
      showMarkAsCompleted: false,
      orderType:"",
      order:"",
      stocktake:{name:"Default_name"
      },
      tab:'menu',
      showSummary:false,
      barcode:"",
      item: false,
      autofocus: true,
      disable: false,
      loading: false,
      firstLoad: true,
      stocktakeId: "",
      stocktakeName:"",
      stocktakeStatus:"",
      stocktakeActive:"",
      stocktakeLastUpdate:"",
      scannedItems: [],        
      scannedITUsL: [],
      innerCols:[
            {
            label: 'BC',
            field: 'id',
            name: 'barcode',
            required: false,
            align: 'center',
            sortable: false
        },

      ],
      columns: [
        {
            name: 'action',
            required: false,
            align: 'center',
            sortable: false
        },        
        {
            name: 'firstCol',
            required: false,
            align: 'left',
            sortable: false
        },
        {
            name: 'secondCol',
            required: false,
            align: 'left',
        }
]
    }   
  },
  async mounted(){
    await this.loadOrder();
  },
  computed:{
    id() {
      return this.$route.params.id;
    },
  },  
  methods:{
    async swapItem(selectedItemToSwap,newItem){
        let itemToSwap = {};
        Object.assign(itemToSwap,itemToSwap,newItem) 
        this.swapItemDialog = false;
        let skuId = selectedItemToSwap.row.sku.id;
        itemToSwap.status = `Assigned to order ${this.order.orderNumber}`;
        itemToSwap.check = true;
        itemToSwap.checkDate = new Date();
        itemToSwap.checkBy = "";
        itemToSwap.deleted = false;
        delete itemToSwap.sku;
        delete itemToSwap.product;
        delete itemToSwap.__typename;
        //Edit ITU (replace the content with this one)
        if(this.orderType == "stock"){
            await this.editItemITU_mutation(this.order.id,skuId,selectedItemToSwap.row.id,itemToSwap);                
        }
        if(this.orderType == "retail"){
            await this.editItemITURetail_mutation(this.order.id,skuId,selectedItemToSwap.row.id,itemToSwap);                
        }
        
        //Edit old ITU (set to available)
        await this.updateItu_mutation (selectedItemToSwap.row.id,{status:"available"});
        await this.updateItu_mutation (itemToSwap.id,{status:`Assigned to order ${this.order.orderNumber}`});

        //Update order.
        for(let i in this.order.items){
            let item = this.order.items[i];
            for(let j in item.itus){
                let itu = item.itus[j]
                if(itu.id == selectedItemToSwap.row.id){                   
                    Object.assign(this.order.items[i].itus[j],this.order.items[i].itus[j],itemToSwap)
                }
            }
        }        
        //recheck if completed
        this.checkIfCompleted(skuId);
    },
    async assignItemtoOrder(selectedProduct,itemToAssign){
        let skuId = selectedProduct.row.sku.id;
        let newItem = {};
        Object.assign(newItem,newItem,itemToAssign)
        newItem.status = `Assigned to order ${this.order.orderNumber}`;
        newItem.check = true;
        newItem.checkDate = new Date();
        newItem.checkBy = "";
        newItem.deleted = false;
        delete newItem.sku;
        delete newItem.product;
        delete newItem.__typename;
    
        for(let i in this.order.items){
            let item = this.order.items[i];
            if(String(item.skuId) == skuId){
                this.order.items[i].itus.push(newItem)
            }
        }
        if(this.orderType == "stock"){
            await this.addItemITU_mutation(this.order.id,skuId,newItem);
        }

        if(this.orderType == "retail"){
            await this.addItemITURetail_mutation(this.order.id,skuId,newItem);
        }        
        this.checkIfCompleted(skuId);
        this.selectedProduct,this.itemToAssign = ""

    },
    disableAssignBtn(selectedProduct,itemToAssign){
            if(!selectedProduct || !itemToAssign ) return true;
            if(itemToAssign.product.id != selectedProduct.row.sku.product.id) return true;
            if(itemToAssign.status != 'available') return true;
            return false;
    },
    disableSwapBtn(itemA,itemB){
            if(!itemA || !itemB ) return true;
            if(itemB.product.id != itemA.row.sku.product.id) return true;
            if(itemB.status != 'available') return true;
            return false;
    },          
    async scanBarcodeToAssign(barcode){
        this.itemToAssign = await this.ituBarcode_query(barcode);
        this.barcodeToAssign = undefined;
    },
    async scanBarcodeToSwap(barcode){
        this.itemToSwap = await this.ituBarcode_query(barcode);
        this.barcodeToSwap = undefined;
    },    
    async showAssignItemDialog(props){
        this.selectedProduct = props;
        this.assignItemDialog = true;
    },
    async showSwapItemDialog(props){        
        this.selectedItemToSwap = props;
        this.swapItemDialog = true;
    },    
    async printPackingList(){
        await this.generatePackingSlipPDF();
    },    
    async completeOrderPacking(){
        this.showSummary = false;
        this.setAsPacked();
        await this.loadOrder();
    },
    async setAsPacked(){
        if(this.orderType == 'stock'){
            await this.editOrder_mutation(this.order.id,{packed:new Date()});
        }

        if(this.orderType == 'retail'){
            await this.editRetailOrder_mutation(this.order.id,{packed:new Date()});
        }        
        
    },
    async markAsCompletedToogle(prop){
        this.showMarkAsCompleted = true;
        this.propData = prop;
    },
    async toogleCompleted(){       
        if(this.orderType == 'stock'){
            await this.editItemInOrder_mutation(this.order.id,this.propData.row.skuId,{completed:!this.propData.row.completed});
        }
        if(this.orderType == 'retail'){
            await this.editItemInRetailOrder_mutation(this.order.id,this.propData.row.skuId,{completed:!this.propData.row.completed});
        }               
        this.propData.row.completed = !this.propData.row.completed;
    },
    async loadOrder(){
        this.order = "";
        if(this.orderType == "stock"){
            this.order = await this.stockOrder(this.id);
        }else if(this.orderType == "retail"){
            this.order = await this.retailOrder(this.id);
        }else{
            let stock = await this.stockOrder(this.id);
            if(stock){
                for(let i in stock.items){
                    let item = stock.items[i];
                    for(let j in item.itus){
                        stock.items[i].itus[j].sku = stock.items[i].sku;
                    }
                }                
                this.order = stock;
                this.orderType = "stock"
            }else{
                let retail = await this.retailOrder(this.id);
                for(let i in retail.items){
                    let item = retail.items[i];
                    for(let j in item.itus){
                        retail.items[i].itus[j].sku = retail.items[i].sku;
                    }
                }           
                this.order = retail;
                this.orderType = "retail"
            }
        }
    },
    async removeScannedItemFromOrder(itemToRemove){
        for(let i in this.order.items){
            let item = this.order.items[i];
            for(let j in item.itus){
                let itu = item.itus[j];
                if(String(itu.id) == itemToRemove.id){
                    this.order.items[i].itus[j].check = false;
                    if(this.orderType == "stock"){
                        await this.editItemITU_mutation(this.order.id,item.skuId,itu.id,{
                                check: false,
                                checkDate: ""
                        });
                    }
                    if(this.orderType == "retail"){
                        await this.editItemITURetail_mutation(this.order.id,item.skuId,itu.id,{
                                check: false,
                                checkDate: ""
                        });
                    }                    
                    this.checkIfCompleted(item.skuId);
                }
            }
        }
    },    
    getSecondLine(item){       
        let line = ""
        if(item.brand) line = line + item.brand + " | ";
        if(item.range) line = line + item.range + " | ";        
        if(item.manufacturer) line = line + item.manufacturer + " | ";
        if(item.material) line = line + item.material + " | ";
        if(item.size) line = line + item.size + " | ";
        if(item.holds) line = line + "Holds: " + item.holds + " | ";
        if(item.type) line = line + item.type;        
        return line
    },    
    async scanItem(barcode){
        this.barcode = null
        this.loading = true        
        this.item = await this.ituBarcode_query(barcode);
        this.barcode = ''
        this.loading = false;            
        this.firstLoad = false;        
        let itu = {
            id: this.item.id,
            barcode: this.item.barcode,
            type: this.item.type,
            status: this.item.status,
            skuIndex: this.item.skuIndex,
            index: this.item.index,
            skuId: this.item.sku.id
        };
        for(let i in this.order.items){
            let item = this.order.items[i]
            if(String(item.skuId) == String(this.item.sku.id)){
                for(let j in item.itus){
                    let itu = item.itus[j];
                    if((String(itu.id) == String(this.item.id) && !this.order.items[i].itus[j].check)){
                        this.order.items[i].itus[j].check = true;
                        if(this.orderType == "stock"){
                            await this.editItemITU_mutation(this.order.id,this.item.sku.id,this.item.id,{
                                check: true,
                                checkDate: new Date()
                            })
                        }

                        if(this.orderType == "retail"){
                            await this.editItemITURetail_mutation(this.order.id,this.item.sku.id,this.item.id,{
                                check: true,
                                checkDate: new Date()
                            })
                        }

                        //Check if adding this item completes the required sets.
                        this.checkIfCompleted(this.item.sku.id);
                    }
                }
            }
        }
    },
    async checkIfCompleted(skuId){
        for(let i in this.order.items){
            let item = this.order.items[i];
            if(String(item.skuId) == String(skuId)){
                let currentQty = 0
                for(let itu of item.itus){
                    if(itu.check) currentQty++
                }
                if(item.qty == currentQty){
                    this.order.items[i].completed = true;
                    if(this.orderType == 'stock'){
                        await this.editItemInOrder_mutation(this.order.id,skuId,{completed:true})
                    }
                    if(this.orderType == 'retail'){
                        await this.editItemInRetailOrder_mutation(this.order.id,skuId,{completed:true})
                    }                    
                }else{
                    if(this.order.items[i].completed) this.order.items[i].completed = false;
                    if(this.orderType == 'stock'){
                        await this.editItemInOrder_mutation(this.order.id,skuId,{completed:false});
                    }
                    if(this.orderType == 'retail'){
                        await this.editItemInRetailOrder_mutation(this.order.id,skuId,{completed:false});
                    }                    
                }
            }
        }
    },
    async warningVibrate(){
        let x = navigator.vibrate([10,200,200,100,200])
        // var snd = new Audio("data:audio/mp3;base64,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");  
        var snd = new Audio("data:audio/wav;base64,SUQzAwAAAAAfdlRJVDIAAAA2AAAAbWVudSBzZnggIHdyb25nICAgaW52YWxpZCBzZWxlY3Rpb24gICAxMSBzb3VuZCBlZmZlY3RUUEUxAAAAFAAAAGZyZWVzb3VuZGVmZmVjdC5uZXRUQUxCAAAAFAAAAGZyZWVzb3VuZGVmZmVjdC5uZXRUWUVSAAAABQAAADIwMTZUQ09OAAAABQAAAFJvY2tDT01NAAAADwAAAGVuZwBleGNlbGxlbnQhVFJDSwAAAAYAAAAwNC8xNgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/zggAAAmQk/SCjAACEyEn6QUYAAQpbZABn934hwAgeAwugQIUAZ/IFLbIAM/u/EOAEDwGF0CBCgDP5AFWlYlmu3o/GKxoPR9jHn+SJfxAO4i9DG0YzfQ8DAy9wX2MbqBYA4CJgpXG/SnI3AJF047HFqpznqqLOOO/usxRtSYiossMBVyKC5qSA38VN7f/BBr6DIrV/+oXu6RWPq//uTfs6zIVYPa8WSNWq0rEs129H4xWNB6PsY8/yRL+IB3EXoY2jGb6HgYGXuC+xjdQLAHAR//OCAJUNpGNS386wARtIxqW/nWACMFK436U5G4BIunHY4tVOc9VRZxx391mKNqTEVFlhgKuRQXNSQG/ipvb/4INfQZFav/1C93SKx9X/9yb9nWZCrB7XiyRqwGvkt23A3hWi0810wEGTBhROmF46ofTGg3Dg61hr0KznbNTQPiATlxw0CHAifONSgTlEuHObti4nKFwIpz3NahMoXU4LH2H5JvetrKWP6P2JrLlKhpzN2JQTa+S3bcDeFaLTzXTAQZMGFE6YXjqh9MaDcODrWGv/84IAdgsgKUwv7gABFkBSmF/cAALQrOds1NA+IBOXHDQIcCJ841KBOUS4c5u2LicoXAinPc1qEyhdTgsfYfkm962spY/o/YmsuUqGnM3YlBOVWr3JJLbXasvG/DnNIHQmYcHhuGmHpMZiI40uHmWxrCjnYFoacXgCChpRoJuPIPJ/CSXkhzSrDSjQrCqDZFbCrjKwiKXJcLKam9X1NRNK7//9NmnFbkuFFNMui1N6pVavckkttdqy8b8Oc0gdCZhweG4aYekxmIjjS4eZbGsKOf/zggCAC8gzVs9zZiUXkGatnubMStgWhpxeAIKGlGgm48g8n8JJeSHNKsNKNCsKoNkVsKuMrCIpclwspqb1fU1E0rv//02acVuS4UU0y6LU3qBQlS6yCSSCZpKOEvex1lyJohAIxFUKRiAdOha6Vip1DEXE02CNnbVxnJcJsI2QI2Jhl1CxUUb+oXZ/FCRoChUWDxoGRQW/ULkTKhYV1C6hKl1kEkkEzSUcJe9jrLkTRCARiKoUjEA6dC10rFTqGIuJpsEbO2rjOS4TYRsgRsTD//OCAH8JvEEp26wkABN4glO3WEgALqFioo39Quz+KEjQFCosHjQMigt+oXImVCwrqFzWvWk4oNhsNiQajYDZVWBGCo0vwy23fM8x7NdTpODrYPny3pMxoMmHlkn4OPsCQdBwn9PZk99n3/+c+Hn7bhgHwOHifKdyPw+GMpZT/KBgPo3h+fmv+sp+GIYmZ////33/TrXrScUGw2GxINRsBsqrAjBUaX4ZbbvmeY9mup0nB1sHz5b0mY0GTDyyT8HH2BIOg4T+nsye+z7//OfDz9v/84IAnww0X1bfzqyRGGi+rb+dWSJwwD4HDxPlO5H4fDGUsp/lAwH0bw/PzX/WU/DEMTM////77/pAvr+S7bcDtLAMVlSCIxOKDHaSO6+Y9uTjGImDg9NrCuLLQoARKCoKhKCoKgqRzruhj3+wKOUoREMRA0E0NyQTGooJHRmsr7vxT/qQSurcu65pW+v5LttwO0sAxWVIIjE4oMdpI7r5j25OMYiYOD02sK4stCgBEoKgqEoKgqCpHOu6GPf7Ao5ShEQxEDQTQ3JBMaigkdGayv/zggCXCjAhUH/uAAEUYEKg/9wAAvu/FP+pBK6ty7rmlYar/9ySOtCYAcNpEqJAeYDHxn7KnNTIZMBI0GiqBwntjgX6DyTonUFEwduDBWsJN3KVGCnjQVDIs0TTRc+KqDaXBZYcIPCKiRMMHwGXIEzg8oTIPHLYTc5Vl8oSJuAi5C5f/tvVY1w1RMg4ctBJpwcsmQPnF02qohqv/3JI60JgBw2kSokB5gMfGfsqc1MhkwEjQaKoHCe2OBfoPJOidQUTB24MFawk3cpUYKeNBUMi//OCALAO+FdMe3GDNx3wrpj24wZuzRNNFz4qoNpcFlhwg8IqJEwwfAZcgTODyhMg8cthNzlWXyhIm4CLkLl/+29VjXDVEyDhy0EmnByyZA+cXTaqgIAHbd9tt//HpTxolEQOhcSBcRT4KUgIGJBsKgICkTowqnKpaFAKytFrBoCQwYoqRJBQeAkMYMAqWnR4wqSY5+2rwoPSS////tHgIsSYdHD0t1FUtOvUVRAA7bvttv/49KeNEoiB0LiQLiKfBSkBAxINhUBAUidGFU5VLQr/84IAfArsM1jfJOMlFdhmsb5JxkoBWVotYNASGDFFSJIKDwEhjBgFS06PGFSTHP21eFB6SX///9o8BFiTDo4eluoqlp16iqD////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////zggCJCMABLgAAAAAAAAJcAAAAAP////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////8AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//OCAP8XgAEuAAAAAAAAAlwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA=");  
        snd.play();        
        return true
    },  
    async stockOrder(id){
        try{  
            let response = await this.$apollo.query({
            query: gql`
                query order ($id: ID!) {
                    order (id: $id) {
                        id
                        orderNumber
                        name
                        notes
                        createdAt
                        totalCost
                        preOrder
                        allowSubstitutions                
                        account {
                        id
                        companyName
                        }
                        placed
                        paid
                        verified
                        packed
                        shipped
                        delivered
                        items {
                            itus   
                            id
                            skuId
                            stockType
                            ETA
                            completed
                            sku {
                                id
                                options
                                price
                                stock                           
                                product {
                                    id
                                    name
                                    reference
                                    attributes
                                    images {
                                        url
                                    }
                                    urlSlug
                                }
                            }
                            qty
                            notes
                            itemCost
                            discountPercent
                            totalCost
                        }
                    }
                }
            `,
            variables: {
            id: id
            },
            fetchPolicy: 'network-only',
            })
            return response.data.order;                       
        }catch(e){
            console.log('error',e);
        }
    },
    async retailOrder(id){
        try{  
            let response = await this.$apollo.query({
            query: gql`
                query retailOrder ($id: ID!) {
                    retailOrder (id: $id) {
                        id
                        orderNumber
                        name
                        notes
                        createdAt
                        totalCost
                        totalCostOfItems
                        voucherDiscountAmount
                        voucherId
                        shipping {
                            cost
                            address {
                                contactName
                                contactLastname
                                address
                                address2
                                city
                                state
                                postCode
                                country
                                phoneNumber
                            }
                        }
                        account {
                            id
                            companyName
                        }
                        placed
                        paid
                        verified
                        packed
                        shipped
                        delivered
                        items {
                            id
                            skuId
                            itus
                            completed
                            sku {
                                id
                                options
                                retailPrice
                                stock
                                product {
                                    id
                                    name
                                    reference
                                    attributes
                                    images {
                                        url
                                    }
                                    urlSlug
                                }
                            }
                            qty
                            notes 
                            itemCost
                            discountPercent
                            totalCost
                        }
                    }
                }
            `,
            variables: {
            id: id
            },
            fetchPolicy: 'network-only',
            })
            return response.data.retailOrder;                       
        }catch(e){
            console.log('error',e);
        }
    },    
    async ituBarcode_query(barcode){
         navigator.vibrate(300)
        var snd = new Audio("data:audio/wav;base64,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");  
        snd.play();
        try{  
            let response = await this.$apollo.query({
            query: gql`
                query ituByBarcode($barcode: String!) {
                ituByBarcode(barcode: $barcode){
                    id
                    barcode
                    paidPrice
                    type
                    status
                    weight
                    skuIndex
                    index
                    sku{

                        id
                        options
                    }
                    product{
                        id
                        name
                        reference
                        attributes
                        images {
                          url
                        }
                    }
                    createdAt
                    updatedAt
                }
                }
            `,
            variables: {
                barcode: barcode
            },
            fetchPolicy: 'network-only',
            })
            // this.barcode = ''
            // this.loading = false;            
            // this.firstLoad = false;
            return response.data.ituByBarcode;                       
        }catch(e){
            // this.barcode = ''
            // this.loading = false
            // this.firstLoad = false;
            return false;
        }
    },
    async editItemITU_mutation(id,skuId,ituId,input){
        let response = await this.$apollo.mutate({
          mutation: gql`
            mutation editItemITU($id:ID!,$skuId:ID!,$ituId:ID!,$input:JSON){
              editItemITU(id:$id,skuId:$skuId,ituId:$ituId,input:$input,){
                id
              }
            }
          `,
            variables: {
                id: id,
                skuId:skuId,
                ituId:ituId,
                input:input
            },           
        })
        this.editItemITU_response = response.data.editItemITU        
    },
    async addItemITU_mutation(id,skuId,input){
        let response = await this.$apollo.mutate({
          mutation: gql`
            mutation addItemITU($id:ID!,$skuId:ID!,$input:JSON){
              addItemITU(id:$id,skuId:$skuId,input:$input,){
                id
              }
            }
          `,
            variables: {
                id: id,
                skuId:skuId,
                input:input
            },           
        })
        await this.loadOrder();
        // this.addItemITU_response = response.data.addItemITU        
    },
    async editItemITURetail_mutation(id,skuId,ituId,input){
        let response = await this.$apollo.mutate({
          mutation: gql`
            mutation editItemITURetail($id:ID!,$skuId:ID!,$ituId:ID!,$input:JSON){
              editItemITURetail(id:$id,skuId:$skuId,ituId:$ituId,input:$input,){
                id
              }
            }
          `,
            variables: {
                id: id,
                skuId:skuId,
                ituId:ituId,
                input:input
            },           
        })
        this.editItemITURetail_response = response.data.editItemITURetail        
    },
    async addItemITURetail_mutation(id,skuId,input){        
        let response = await this.$apollo.mutate({
          mutation: gql`
            mutation addItemITURetail($id:ID!,$skuId:ID!,$input:JSON){
              addItemITURetail(id:$id,skuId:$skuId,input:$input,){
                id
              }
            }
          `,
            variables: {
                id: id,
                skuId:skuId,
                input:input
            },           
        })
            await this.loadOrder();
        // this.addItemITURetail_response = response.data.addItemITURetail        
    },         
    async editItemInOrder_mutation(id,skuId,input){
        let response = await this.$apollo.mutate({
          mutation: gql`
            mutation editItemInOrder($id:ID!,$skuId:ID!,$input:OrderItemInput!,$update_stock:Boolean){
              editItemInOrder(id:$id,skuId:$skuId,input:$input,update_stock:$update_stock){
                id
              }
            }
          `,
            variables: {
                id: id,
                skuId:skuId,
                input:input,
                update_stock:false                
            },           
        })
        // this.editItemInOrder_response = response.data.editItemInOrder        
    },
    async editItemInRetailOrder_mutation(id,skuId,input){
        let response = await this.$apollo.mutate({
          mutation: gql`
            mutation editItemInRetailOrder($id:ID!,$skuId:ID!,$input:RetailOrderItemInput!,$update_stock:Boolean){
              editItemInRetailOrder(id:$id,skuId:$skuId,input:$input,update_stock:$update_stock){
                id
              }
            }
          `,
            variables: {
                id: id,
                skuId:skuId,
                input:input,
                update_stock:false                
            },           
        })
        // this.editItemInRetailOrder_response = response.data.editItemInRetailOrder        
    },    
    async editOrder_mutation(id,input){
        let response = await this.$apollo.mutate({
          mutation: gql`
            mutation editOrder($id:ID!,$input:OrderInput!){
              editOrder(id:$id,input:$input){
                id
              }
            }
          `,
            variables: {
                id: id,
                input:input,
            },           
        })
        // this.editOrder_response = response.data.editOrder        
    },
    async editRetailOrder_mutation(id,input){
        let response = await this.$apollo.mutate({
          mutation: gql`
            mutation editRetailOrder($id:ID!,$input:RetailOrderInput!){
              editRetailOrder(id:$id,input:$input){
                id
              }
            }
          `,
            variables: {
                id: id,
                input:input,
            },           
        })
        // this.editOrder_response = response.data.editOrder        
    },    
async generatePackingSlipPDF() {
      const doc = new jsPDF({filters: ['ASCIIHexEncode']});
      let tableData = [];
      let totalHolds = 0;
      let totalItems = 0;
      this.order.items.forEach(item => {
        let brand, range, name, colour, holds, qty,check;
        totalItems += Number(item.qty);
        totalHolds += Number(item.sku.product.attributes.holds) * Number(item.qty);
        qty = "" + item.qty;
        brand = item.sku.product.attributes.brand || " ";
        range = item.sku.product.attributes.range || " ";
        holds = item.sku.product.attributes.holds || " ";
        name = item.sku.product.name || " ";
        check = (item.completed)?"Y":""
        colour = `${item.sku.options.colour.group || " "}\n(${item.sku.options.colour.name || " "})`;
        tableData.push({ Brand: brand, Range: range, Name: name, Colour: colour, Holds: holds, Qty: qty, Check: check })
      });

      //Logo
      doc.addImage("/img/logo.png", "PNG", 10, 10, 20, 20);

      //TITLE
      doc.setFontSize(14);
      doc.text("PACKING SLIP", 35, 30);
      doc.setFontSize(12);
      doc.text(`Order: ${this.order.orderNumber}`, 40, 35)

      let accountDetails = await this.getAccountDetails(this.order.account.id);     

      let capCompany = this.order.account.companyName ? _.startCase(_.toLower(this.order.account.companyName)) : "";
      let capName = _.startCase(_.toLower(accountDetails.contactName));
      // let capLastname = this.order.shipping.address.contactLastname ? _.startCase(_.toLower(this.order.shipping.address.Lastname)) : "";

      //ORDER CUADRANT
      doc.setFontSize(12);
      doc.text(`Total Items (sets): ${totalItems}`, 10, 50);
      doc.text(`Total Holds: ${totalHolds}`, 10, 55);
      doc.text("Packed by:____________", 10, 65);

      //CUSTOMER CUADRANT
      let initialYPosition = 20;
      doc.setFontSize(12);
      doc.text("Ship to:", 110, initialYPosition);
      if (this.order.account.companyName) doc.text(`${capCompany || ""}`, 113, initialYPosition += 5)
      doc.text(`${capName}`, 113, initialYPosition += 5)
      if (accountDetails.contactPhone) doc.text(`ph: ${accountDetails.contactPhone || ""}`, 113, initialYPosition += 5)
      // doc.text(`${this.order.shipping.address.address}`, 113, initialYPosition += 5)
      if (accountDetails.shippingAddress) doc.text(`${accountDetails.shippingAddress || ""}`, 113, initialYPosition += 5)
      // doc.text(`${this.order.shipping.address.city},${this.order.shipping.address.state},${this.order.shipping.address.postCode}`, 113, initialYPosition += 5)
      // doc.text(`${this.order.shipping.address.country}`, 113, initialYPosition += 5)

      //ITEMS (TABLE)        
      let headers = [
        {
          align: "center",
          id: "Brand",
          name: "Brand",
          padding: 0,
          prompt: "Brand",
          width: 30,
        },
        {
          align: "center",
          id: "Range",
          name: "Range",
          padding: 0,
          prompt: "Range",
          width: 35,
        },
        {
          align: "center",
          id: "Name",
          name: "Name",
          padding: 0,
          prompt: "Name",
          width: 80,
        },
        {
          align: "center",
          id: "Holds",
          name: "Holds",
          padding: 0,
          prompt: "Holds",
          width: 23,
        },
        {
          align: "center",
          id: "Colour",
          name: "Colour",
          padding: 0,
          prompt: "Colour",
          width: 40,
        },
        {
          align: "center",
          id: "Qty",
          name: "Qty",
          padding: 0,
          prompt: "Qty",
          width: 20,
        },
        {
          align: "center",
          id: "Check",
          name: "Check",
          padding: 0,
          prompt: "",
          width: 23,
        },
      ]
      doc.table(10, 80, tableData, headers, { fontSize: 9, autoSize: false, margins: { left: 0, top: 15, bottom: 10, right: 0 } });
      doc.autoPrint();
      doc.output('dataurlnewwindow');
      return
    },
    async getAccountDetails(accountId){
      try {
        let res = await this.$apollo.query({
          query: gql`query account($id: ID!) {
              account(id: $id) {
                id
                email
                companyName
                ABNACN
                contactName
                contactPosition
                contactPhone
                shippingAddress
                addresses{
                  info
                  contactName
                  contactLastname
                  company
                  address
                  address2
                  city
                  country
                  state
                  postCode
                  phoneNumber
                  shippingNotes
                }
                verifiedAt
                createdAt
                updatedAt
                isAdmin
                standardDiscountPercent
                roles
                colourFavourites
                activeCartId
                activeContainerCartId
                activeRetailCartId
              }
            }`,
          variables: {
            id: accountId
          }
        })
        return res.data.account;
      } catch (error) {
        console.log(error)
      }      
    },
    async updateItu_mutation (ituId,input){
        let response = await this.$apollo.mutate({
          mutation: gql`
            mutation updateItu($ituId: ID!, $input: ItuInput) {
              updateItu(ituId: $ituId, input: $input)
              {
                id
                barcode
                paidPrice
                type
                status
                weight
                updatedAt
                createdAt
                deleted
              }
            }
          `,
          variables:{
            ituId: ituId,
            input: input
          }
        })
        // this.updateITU_response = response.data.updateItu        
    },                                      
  }
}
</script>

<style lang="stylus" scoped>
.scroll_content::-webkit-scrollbar {
    display: none;
}
.scroll_content{
    padding: 0 5px;
}

</style>